import { render, staticRenderFns } from "./ButtonBase.vue?vue&type=template&id=49f206f6&scoped=true"
import script from "./ButtonBase.vue?vue&type=script&lang=js"
export * from "./ButtonBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f206f6",
  null
  
)

export default component.exports